import axios from 'axios'

const baseUrl = `${window.location.origin}`
const defaultTimeout = 5000  // 5 seconds

export const httpClient = axios.create({
  baseURL: baseUrl,
  timeout: defaultTimeout,
})
